import React from 'react';

function LandingPage() {
  const containerStyle = {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #6665dd 0%, #000500 100%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '40px 20px',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif'
  };

  const contentStyle = {
    maxWidth: '900px',
    textAlign: 'center',
    color: 'white',
    padding: '80px 50px',
    background: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '20px',
    backdropFilter: 'blur(15px)',
    boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
    border: '1px solid rgba(255, 255, 255, 0.2)'
  };

  const titleStyle = {
    fontSize: '4.5rem',
    fontWeight: '300',
    marginBottom: '40px',
    lineHeight: '1.1',
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.3)',
    letterSpacing: '-2px'
  };

  const subtitleStyle = {
    fontSize: '1.8rem',
    fontWeight: '300',
    marginBottom: '50px',
    lineHeight: '1.5',
    opacity: '0.95',
    color: '#b3b3f7'
  };

  const stealthStyle = {
    fontSize: '1.1rem',
    fontWeight: '400',
    opacity: '0.9',
    fontStyle: 'italic',
    color: '#b3b3f7',
    marginTop: '30px'
  };

  return (
    <div style={containerStyle}>
      <div style={contentStyle}>
        <h1 style={titleStyle}>amsense</h1>
        <p style={subtitleStyle}>
          Empowering IoT Through AI-Driven Intelligence and Connectivity
        </p>
        <p style={stealthStyle}>
          We're building the future of intelligent machine communication.
          <br />
          Something amazing is coming soon.
        </p>
      </div>
    </div>
  );
}

export default LandingPage;